import { BaseApi } from './base';
import type { User } from './types';

export class UsersApi extends BaseApi {
  public async getAll(): Promise<User[]> {
    return await this._request<User[]>('/users', {
      method: 'GET',
    });
  }

  public async getCurrent(): Promise<User> {
    return await this._request<User>('/users/current', { method: 'GET' });
  }

  public async getBalance(userId: string): Promise<number> {
    const response = await this._request<{ balance: number }>(
      `/users/${userId}/balance`,
      {
        method: 'GET',
      },
    );

    return response.balance;
  }
}
